<div class="ark-sidenav-header row m-0">
    <div class="col p-0 d-flex align-items-center justify-content-start">
      <h2 class="ark-h2">{{'general.accountDeactivationMessage' | translate}} {{data?.accountDeactivation?.DeactivationDate}}</h2>
    </div>
    <div class="col col-auto p-0 d-flex justify-content-end align-items-center">
      <a class="btn ark-btn-action close" (click)="onNoClick()">
        <span><i class="fal fa-times"></i></span>
      </a>
    </div>
  </div>
  
  <div class="ark-modal-body">
    <div class="row m-0">
      <div class="col p-0 message">
        <p>{{data?.accountDeactivation?.DeactivationMessage}}</p>
      </div>
    </div>
  </div>